import {
  gsap,
  cameraManager,
  CameraStates,
  MobileDetector,
  corePhasesManager,
  audioManager,
  modes
} from '@powerplay/core-minigames'
import {
  AudioNames,
  Tasks,
  TutorialObjectiveIds,
  type DisciplinePhaseManager
} from '../../types'
import { actionButtonState } from '@/stores'
import { player } from '../../entities/player'
import { inputsManager } from '../../InputsManager'
import { gameConfig } from '../../config'
import { startPhaseStateManager } from './StartPhaseStateManager'
import { playerAnimationManager } from '@/app/entities/player/PlayerAnimationManager'
import { pushbarManager } from '@/app/PushbarManager'
import { playerMovementManager } from '@/app/entities/player/PlayerMovementManager'
import { tutorialFlow } from '@/app/modes/tutorial/TutorialFlow'
import { tutorialUIChange } from '@/app/modes/tutorial/TutorialUIChange'
import { speedManager } from '@/app/SpeedManager/SpeedManager'
import { hill } from '@/app/entities/hill/Hill'
import { trainingTasks } from '@/app/modes/training'
import { tutorialObjectives } from '@/app/modes/tutorial/TutorialObjectives'
import {
  inputsState,
  startPhaseState
} from '@/stores'

/**
 * Trieda pre startovaciu fazu
 */
export class StartPhaseManager implements DisciplinePhaseManager {

  /** ci sa deje nieco skipnutelne */
  private skippable = true

  /** ci uz je mozne odstartovat */
  private startable = false

  /** ci uz zobrazit ui player-info-avatar */
  private showName = false

  /** ci bolo skipnute */
  private skipped = false

  /** ci faza skoncila */
  private ended = false

  /** ci je to uz resestnute */
  public isResetAttempt = false

  /** Pocet frameov od zaciatku fazy */
  private framesInPhase = 0

  /** tween na skrytie odrazovej hlasky */
  public startingMessageTween !: gsap.core.Tween

  /** tween na zacatie disciplinoveho intra */
  private launchSystemTween!: gsap.core.Tween

  /** tween na spustenie pipania */
  private startRunSoundTween!: gsap.core.Tween

  /** timeline na spustenie pipania */
  private startRunSoundTimeline!: gsap.core.Timeline

  /** tween pipania */
  private soundCounterTween!: gsap.core.Timeline

  /** callback na zavolanie po skonceni fazy */
  private callbackEnd: () => unknown

  /** Ci je aktivne spomalenie v tutoriali */
  private slowDownInTutorialEnabled = false

  /** Konstruktor */
  public constructor(callbackEnd: () => unknown) {

    this.callbackEnd = callbackEnd

  }

  /**
   * Vratenie, ci je aktivne spomalenie v tutoriali
   * @returns True, ak je aktivne spomalenie
   */
  public isSlowDownInTutorialEnabled(): boolean {

    return !this.ended && this.slowDownInTutorialEnabled

  }

  /**
   * Aktivovanie spomalenia v tutoriali
   */
  public enableSlowDownInTutorial(coef: number): void {

    if (!modes.isTutorial()) return

    this.slowDownInTutorialEnabled = true
    player.animationsManager.setSpeed(coef)
    speedManager.setSlowDownCoef(coef)
    // pushbarManager.setSlowDownCoef(coef)

  }

  /**
   * Deaktivovanie spomalenia v tutoriali
   */
  public disableSlowDownInTutorial(): void {

    if (!modes.isTutorial()) return

    this.slowDownInTutorialEnabled = false
    player.animationsManager.resetSpeed()
    speedManager.setSlowDownCoef(1)
    // pushbarManager.setSlowDownCoef(1)

  }

  /**
   * Pripravenie fazy
   */
  public preparePhase(): void {

    this.storeState()
    startPhaseStateManager.disableInputs()

  }

  /**
   * Zacatie fazy
   */
  public startPhase(): void {

    if (this.ended) this.reset()

    playerMovementManager.changeMoveLeftRightActive(false)
    console.warn('starting start phase')
    // Zobrazit meno hraca v UI
    this.showName = !modes.isTutorial()
    this.setCameraForDisciplineIntro()

  }

  /**
   * Nastavenie kamery pre intro
   */
  private setCameraForDisciplineIntro(): void {

    if (gameConfig.cameraConfig.enabled) {

      player.changeCameraSettings(
        gameConfig.cameraConfig.idealOffset,
        undefined,
        gameConfig.cameraConfig.coefSize,
        gameConfig.cameraConfig.changeLerp,
        gameConfig.cameraConfig.isStaticMovement
      )

    }
    if (modes.isTutorial()) {

      this.afterCameraDisciplineIntro()
      if (this.isResetAttempt) return
      tutorialFlow.init()
      tutorialUIChange.init()
      return

    }

    cameraManager.setState(CameraStates.disciplineIntro)
    cameraManager.playTween(false, this.afterCameraDisciplineIntro)

  }

  /**
   * Spravenie veci po konci disciplinoveho intra
   */
  private afterCameraDisciplineIntro = (): void => {

    playerAnimationManager.preStartAnimation()
    cameraManager.setState(CameraStates.discipline)
    this.launchSystemTween = gsap.to({}, {
      onComplete: this.launchSystem,
      callbackScope: this,
      duration: 0.5
    })

  }

  /**
   * Spustenie pipania
   */
  private launchSystem = (): void => {

    console.log('launch system')
    this.skippable = false

    cameraManager.setState(CameraStates.discipline)

    const duration = this.skipped ? 1 : 0

    // Zrusit zobrazenie mena hraca v UI
    this.showName = false

    startPhaseStateManager.postIntroUiState()

    player.hillLinesManager.showDebugLinesTriggers()

    hill.setVisibilityOfAllTrackParts(false)
    hill.showFirstTrackParts()

    // davam maly delay kvoli tomu, ze predtym mohol byt skip
    this.startRunSoundTween = gsap.to({}, {
      onComplete: () => {

        console.log('startRunSoundTween complete')
        /*
         * const coef = startUpPhaseConfig.tutorialSlowDownCoef
         * this.enableSlowDownInTutorial(coef)
         */
        this.startable = true
        startPhaseStateManager.enableStartInputs()
        inputsState().actionVisible = true
        startPhaseStateManager.enableInputs()
        pushbarManager.startPush()

      },
      duration
    })

  }

  /**
   * Update kazdy frame
   */
  public update(): void {

    this.framesInPhase += 1

    if (MobileDetector.isMobile()) {

      if (
        this.startable &&
              actionButtonState().touchStart &&
              !pushbarManager.blockedInput
      ) {

        console.log('mobile button pressed')

        pushbarManager.blockedInput = true
        pushbarManager.managePush()
        this.storeState()
        // this.finishPhase()
        this.ended = true

      }

    } else {

      if (
        this.startable &&
                inputsManager.actionPressed &&
                !pushbarManager.blockedInput
      ) {

        console.log('action pressed')

        pushbarManager.blockedInput = true
        pushbarManager.managePush()
        this.storeState()
        // this.finishPhase()
        this.ended = true

      }

    }

    if (!actionButtonState().touchStart && !inputsManager.actionPressed) {

      pushbarManager.blockedInput = false

    }



    if (inputsManager.actionPressed && this.skippable && this.framesInPhase > 10) {

      console.log('skippped')
      this.skippable = false
      this.skipped = true
      cameraManager.skipTween()

    }

    pushbarManager.update()
    this.storeState()

  }

  /**
   * kill all tweens
   */
  private killAllTweens(): void {

    if (this.launchSystemTween) this.launchSystemTween.kill()
    if (this.startRunSoundTween) this.startRunSoundTween.kill()
    if (this.soundCounterTween) this.soundCounterTween.kill()
    if (this.startRunSoundTimeline) this.startRunSoundTimeline.kill()

  }

  /**
   * Ukoncene fazy
   */
  public finishPhase(): void {

    this.startable = false

    if (!this.ended) {

      audioManager.stopAudioByName(AudioNames.audienceNoise)
      audioManager.play(AudioNames.audienceHype)

      console.warn('start phase ended')

      this.ended = true
      this.killAllTweens()
      this.callbackEnd()

      this.storeState()

      startPhaseStateManager.finishPhaseUiState()
      trainingTasks.countTaskValue(Tasks.startUp, pushbarManager.startClickedQuality / 100)
      tutorialObjectives.passObjective(TutorialObjectiveIds.startUp)

    }

  }

  /**
   * sets finish phase tween
   */
  public setFinishPhaseTween(): void {

    //

  }

  /**
   * UI update
   */
  private storeState(): void {

    startPhaseState().$patch({
      clickedPower: 0,
      showName: this.showName,
      showPhase: !this.ended,
      showBar: this.startable && !this.ended,
      attempt: corePhasesManager.disciplineActualAttempt
    })

  }

  /**
   * reset fazy
   */
  public reset(): void {

    inputsState().disabled = true
    this.skippable = true
    this.startable = false
    this.showName = false
    this.skipped = false
    this.ended = false
    this.framesInPhase = 0
    this.storeState()
    tutorialFlow.reset()

  }

}
